/**
 * Per-widget sample data so a moderation preview shows realistic content where
 * the live widget would bind dynamic values. Mirrors the sample data each
 * widget's render adapter feeds in the application. Unknown keys simply fall
 * back to the slot's `fallback`.
 */

import type { RenderData } from "./renderDesign";
import type { DesignWidgetType } from "./serializableDesign";

const SAMPLE: Record<DesignWidgetType, RenderData> = {
  timer: { values: { TIME: "05:00", MM: "05", SS: "00" } },
  countdown: { values: { DD: "02", HH: "08", MM: "30", SS: "15" } },
  clock: {
    values: {
      hh: "14",
      mm: "30",
      time: "14:30",
      h1: "1",
      h2: "4",
      m1: "3",
      m2: "0",
      seconds: "45",
      ampm: "PM",
      weekdayLong: "Saturday",
      weekdayShort: "Sat",
      weekdayLongLower: "saturday",
      day: "21",
      day2: "21",
      monthShort: "Jun",
      monthLong: "June",
      monthLongLower: "june",
      year: "2026",
      gmt: "GMT-3",
      roman: "MMXXVI",
    },
  },
  social: { values: { handle: "@eriol" } },
  viewers: {
    values: {
      total: 1248,
      twitch: 800,
      youtube: 300,
      kick: 148,
      restream: 0,
      facebook: 0,
    },
  },
  subgoal: { values: { current: 66, target: 100, pct: 66 } },
  followergoal: { values: { current: 66, target: 100, pct: 66 } },
  progressbar: { values: { pct: 66 } },
  crawl: {
    values: {
      USER_TEXT: "Eriol — live streaming, your way.",
      SEP: "•",
      SEP_COLOR: "#7c3aed",
    },
  },
  chat: {
    items: [
      { name: "nova", text: "this overlay is clean 🔥", color: "#a78bfa" },
      {
        name: "kai_streams",
        text: "GG, that was a great run",
        color: "#34d399",
      },
      { name: "mara", text: "where's the theme from?", color: "#f472b6" },
      { name: "devon", text: "subbed!", color: "#60a5fa" },
    ],
  },
  playlist: {
    items: [
      { title: "Intro — Starlight", duration: "3:42" },
      { title: "Focus Beats vol. 2", duration: "4:15" },
      { title: "Night Drive", duration: "5:08" },
      { title: "Closing Theme", duration: "2:57" },
    ],
  },
};

export function sampleFor(widgetType: string): RenderData {
  return SAMPLE[widgetType as DesignWidgetType] ?? {};
}
